export const state = () => ({
  brandZzimList: []
})

export const mutations = {
  SET_BRAND_ZZIM_LIST (state, list) {
    console.log('SET_BRAND_ZZIM_LIST 호출됨:', list)
    state.brandZzimList = list
  },
  TOGGLE_BRAND_ZZIM_ITEM (state, { brndCd, brandZzimYn }) {
    if (brandZzimYn === 'Y') {
      state.brandZzimList.push({ brndCd })
    } else {
      state.brandZzimList = state.brandZzimList.filter(i => i.brndCd !== brndCd)
    }
  }
}

export const actions = {
  async fetchBrandZzimList ({ commit, rootGetters }) {
    try {
      const mbMngNo = rootGetters['session/getMbMngNo']
      console.log('mbMngNo:', mbMngNo)
      console.log('mbMngNo 타입:', typeof mbMngNo)

      if (!mbMngNo || mbMngNo === 'undefined' || mbMngNo === '') {
        console.log('유효하지 않은 mbMngNo - 로그인 필요')
        commit('SET_BRAND_ZZIM_LIST', [])
        return []
      }

      console.log('브랜드 찜 API 호출 시작 - mbMngNo:', mbMngNo)
      const response = await this.$axios.post(process.env.API_BASE_URL + '/pdo/selZzimBrand', { mbMngNo })

      const list = response.data?.data?.zzimBrandList?.map(item => ({
        brndCd: item.brndCd
      })) || []

      commit('SET_BRAND_ZZIM_LIST', list)
      return list
    } catch (error) {
      console.error('브랜드 찜 목록 조회 실패:', error)
      commit('SET_BRAND_ZZIM_LIST', [])
    }
  },

  async toggleBrandZzim ({ commit }, brndCd) {
    const res = await this.$axios.post(process.env.API_BASE_URL + '/pdo/tglBrndZzim', { brndCd })
    if (res.data.success) {
      const brandZzimYn = res.data.extraData.zzimYn ? 'Y' : 'N'
      commit('TOGGLE_BRAND_ZZIM_ITEM', { brndCd, brandZzimYn })
      return brandZzimYn
    }
  }
}
